import { EventSourceInput } from '@fullcalendar/core';
import { useState } from 'react';
import useRest from '../useRest';

export const useCalendar = (dataLink?: string) => {
    const rest = useRest();
    const [events, setEvents] = useState<EventSourceInput>([]);
    const [loading, setLoading] = useState(false);

    const getEvents = async (params: Record<string, any>) => {
        if (typeof dataLink === 'string') {
            setLoading(true);

            const { response, isError } = await rest.fetch({
                method: 'post',
                objectName: dataLink,
                data: params,
            });

            if (!isError && response?.data && Array.isArray(response.data)) {
                setEvents(response.data);
            }

            setLoading(false);
        }
    };

    return {
        events,
        getEvents,
        loading,
    };
};
